import React, { Component } from 'react';

import charactorIcon from '../../assets/image/charactor2.svg';

class NextButton extends Component {
  state = {
    // right: window.innerWidth * 0.6,
  };

  componentDidMount() {
    // this.handleResize();
    // window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // window.removeEventListener('resize', this.handleResize);
  }

  // handleResize() {
  //   if (this.container && this.nextButton) {
  //     const isMobile = window.innerWidth <= 960;
  //     const margin = isMobile ? 12 : 16;
  //     const right = (this.container.clientWidth + this.nextButton.clientWidth) * 0.5 + margin;
  //     this.setState({ right });
  //   }
  // }

  onClick = () => {
    if (!this.props.disable) {
      this.props.onClick && this.props.onClick();
    }
  }

  render() {
    const text = '次のステップへ';

    const className = this.props.disable ? 'NextButton' : 'NextButton Active';

    // const logoStyle = {
    //    right: this.state.right,
    // };

    return (
      <div
        className="ShadowContainer"
        ref={node => this.container = node}
      >
        <div
          className={className}
          ref={node => this.nextButton = node}
          onClick={this.onClick}
        >
          {text}
        </div>
        <img className="NextButtonLogo" src={charactorIcon} alt="charactor2" />
      </div>
    );
  }
};


export default NextButton;
